import axios from "axios";

const axiosInstance = axios.create({
    // baseURL: "http://localhost:2010/",
    baseURL: "https://score.planotechevents.com:2010/",
});

export default axiosInstance;